define('app/router',['require'],function(require){

  return Backbone.Router.extend({

    routes: {
      '*path': 'catchall'
    }

  });

});
